'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(r, t) {
    if (null == r) return {};
    var e, o, n = _object_without_properties_loose(r, t);
    if (Object.getOwnPropertySymbols) {
        var p = Object.getOwnPropertySymbols(r);
        for(o = 0; o < p.length; o++)e = p[o], !(t.indexOf(e) >= 0) && Object.prototype.propertyIsEnumerable.call(r, e) && (n[e] = r[e]);
    }
    return n;
}
function _object_without_properties_loose(r, t) {
    if (null == r) return {};
    var e, o, n = {}, p = Object.keys(r);
    for(o = 0; o < p.length; o++)e = p[o], t.indexOf(e) >= 0 || (n[e] = r[e]);
    return n;
}
const FormInputGroup = renderWithRef('FormInputGroup', null, (e, o)=>{
    var { children: n } = e;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: o,
        props: _object_without_properties(e, [
            "children"
        ]),
        classNames: [
            'swan-input-group'
        ],
        children: n
    });
});

export { FormInputGroup };
